import apiClient from '../client';
import type { Database } from '@/lib/supabase/supabase-types';

type WorkExperience = Database['public']['Tables']['work_experience']['Row'];
type WorkExperienceInsert = Database['public']['Tables']['work_experience']['Insert'];
type WorkExperienceUpdate = Database['public']['Tables']['work_experience']['Update'];

export const workExperienceService = {
  /**
   * Get current user's work experience entries
   */
  getMyExperiences: async (): Promise<WorkExperience[]> => {
    const result = await apiClient.get<WorkExperience[]>('/work-experience');
    return result as unknown as WorkExperience[];
  },
  
  /**
   * Get work experience entry by ID (public endpoint)
   */
  getExperience: async (experienceId: string): Promise<WorkExperience> => {
    const result = await apiClient.get<WorkExperience>(`/work-experience/${experienceId}`);
    return result as unknown as WorkExperience;
  },
  
  /**
   * Get all work experience entries for a freelancer profile (public endpoint)
   */
  getExperiencesByProfile: async (profileId: string): Promise<WorkExperience[]> => {
    const result = await apiClient.get<WorkExperience[]>(`/work-experience/profile/${profileId}`);
    return result as unknown as WorkExperience[];
  },
  
  /**
   * Create a new work experience entry
   */
  createExperience: async (data: Omit<WorkExperienceInsert, 'freelancer_profile_id'>): Promise<WorkExperience> => {
    const result = await apiClient.post<WorkExperience>('/work-experience', data);
    return result as unknown as WorkExperience;
  },
  
  /**
   * Update a work experience entry
   */
  updateExperience: async (experienceId: string, data: WorkExperienceUpdate): Promise<WorkExperience> => {
    const result = await apiClient.patch<WorkExperience>(`/work-experience/${experienceId}`, data);
    return result as unknown as WorkExperience;
  },
  
  /**
   * Delete a work experience entry
   */
  deleteExperience: async (experienceId: string): Promise<void> => {
    await apiClient.delete(`/work-experience/${experienceId}`);
  },
};

